import { useTheme } from '@mui/material/styles';

export const ExplorerStyles = () => {
    const theme = useTheme();
    return {
        color: theme.palette.primary.light,
        "& .section--extra-filters .data-filters__item label": {
            width: {
                lg: "100%"
            }
        },
        "& .form-select": {
            margin:{
                xs: "15px 0",
                sm: "30px 0",
                lg: "0 0 40px 0"
            },
            width: {
                lg: "50%"
            }
        },
        "& .var__range-slider": {
            width: {
                lg: "50%"
            },
            padding: {
                lg: "0 0 0 40px"
            }
        },
        "& .reset-data": {
            alignSelf: "center",
            height: "38px"
        },
        "& .data-filters__item": {
            marginBottom: {
                lg: 0,
            },
            display: {
                lg: "flex",
            },
            flexWrap: {
                lg: "wrap"
            },
        },
        "& .section--scatter-data":{
            "& .chart-options": {
              display: {
                xs: "block",
                md: "flex"
              },
              paddingLeft: "8px",
              justifyContent: "space-between",
            },
            "& button": {
              fontSize: ".85rem",
              fontWeight: "bold"
            },
            "& .chart-message": {
              color: theme.palette.primary.main,
              fontSize: "12px",
              padding: {
                md: "0 12px",
              },
              marginTop: {
                xs: "12px",
                md: 0
              }
            }
        },
        "& .extra-filters__actions": {
            paddingTop: {
                xs: "20px",
                lg: "0",
            },
            display: "flex",
            justifyContent: "space-around"
        },
        "& .chart-footer-data": {
            fontSize: "12px",
            padding: " 10px 16px"
        },
        "& .slides-info": {
            fontSize: "14px",
            textAlign: "right",

            "& svg": {
                color: theme.palette.primary.light
            }
        },
        "& .chart-options": {
            display: "flex",
            alignItems: "center"
        },
        "& .bubbleSizeContainer": {
            display: "flex",
            alignItems: "center",
            width: "380px",
        },
        "& .bubbleSizeContainer .bubbleSizeLabel": {
            fontSize: "12px",
        },
        "& .z-axis-tooltip": {
            position: {
                sm: "absolute"
            },
            top: {
                sm: "-4px"
            }
        },
        "& .z-axis-tooltip+label": {
            paddingLeft: {
                sm: "20px"
            }
        },
        "& .z-data-filter": {
            position: "relative",
        },
        "& .section--histogram-x": {
            gridColumn: {
                lg: "1 / 3"
            }
        },
        "& .section--histogram-y": {
            gridColumn: {
                lg: "3 / 5"
            }
        },
        "& .section--histogram-z": {
            gridColumn: {
                lg: "5 / 7"
            }
        },
    }
}
